import React from 'react';
import '../../styles/sections/Footer.css';

function Footer() {
  const currentYear = new Date().getFullYear();

  return (
    <footer id="footer" className="footer">
      <div className="footer-content">
        <div className="footer-section">
          <h3>Get in Touch</h3>
          <p>Questions? We'd love to hear from you!</p>
          <a href="mailto:support@printmytile.com" className="footer-email">
            support@printmytile.com
          </a>
        </div>
        <div className="footer-section">
          <h3>Links</h3>
          <ul>
            <li>
              <a href="/terms" target="_blank" rel="noopener noreferrer">
                Terms & Conditions
              </a>
            </li>
            <li>
              <a href="/privacy" target="_blank" rel="noopener noreferrer">
                Privacy Policy
              </a>
            </li>
            <li>
              <a href="#faq">FAQs</a>
            </li>
          </ul>
        </div>
        <div className="footer-section">
          <h3>About Us</h3>
          <p>
            We create custom printed ceramic tiles that preserve your special moments. 
            Each tile is carefully crafted and shipped from Dandenong, Victoria.
          </p>
        </div>
      </div>
      <div className="footer-bottom">
        <div className="footer-bottom-content">
          <p>Made with <span className="heart">♥</span> in Australia</p>
          <p>&copy; {currentYear} PrintMyTile • All rights reserved</p>
        </div>
      </div>
    </footer>
  );
}

export default Footer; 